/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useContext } from 'react';

import { RicosContext } from './../../ricos-context';

import { AiIcon } from './ai-icon';
import styles from './toolbar-button-scss';

export const ToolbarButton: React.FC<{ toggle: () => void; showLabel: boolean }> = ({
  toggle,
  showLabel,
}) => {
  const { t } = useContext(RicosContext);
  return (
    <span className={styles.button} onClick={toggle}>
      <AiIcon /> {showLabel && t('AIPlugin_ToolbarButton_Text')}
    </span>
  );
};
